export class LoginState {
	// Store email address
	public email: string = "";

	// Store password
	public password: string = "";
}